import { csx } from '@vtex/admin-ui'

export const styles = {
  card: {
    item: csx({
      ':hover': {
        a: {
          opacity: 1,
        },
      },
    }),
    header: csx({
      cursor: 'pointer',
      padding: '$space-1 $space-2',
      ':hover': {
        background: '$secondary',
      },
      '[data-visible="true"]': {
        borderBottom: '$neutral',
        background: '$secondary',
      },
    }),
    info: csx({
      display: 'flex',
      gap: '$space-2',
      padding: '$space-1',
    }),
    actions: csx({
      display: 'flex',
      alignItems: 'center',
      gap: '$space-2',
    }),
    content: csx({ padding: '0 $space-4' }),
    line: csx({
      display: 'grid',
      gap: '1rem',
      '[data-columns="fill"]': {
        gridTemplateColumns: 'auto 2.5rem',
      },
      '[data-columns="split"]': {
        gridTemplateColumns: '1fr 1fr',
      },
      alignItems: 'center',
      padding: '$space-3 $space-2',
      ':not(.card-line:last-of-type)': {
        borderBottom: '$neutral',
      },
    }),
    example: csx({
      display: 'flex',
      flexDirection: 'column',
      margin: '$space-2 0',
      gap: '$space-1',
    }),
    anchor: csx({
      opacity: 0,
      '> button': {
        cursor: 'pointer',
        '> div': {
          border: '1px solid $gray50',
          color: '$gray50',
          background: 'none',
        },
      },
    }),
  },
}
